/**
 * Dashboard Dedicated Store
 *
 * @since 2018-11-06
 * @author mk.ko
 *
 * 2018-11-16 대시보드 내 전용 단일화면 Store 통합
 */

export const state = () => ({
  refreshTime: 10,
  filterDate: 0,
  filterIpType: 'v46',
  filterDevice: void 0,
  filterDeviceText: '',
  filterDeviceNot: false,
  countrySubject: ''
})

export const mutations = {
  initTopStore (state) {
    state.refreshTime = 10
    state.countrySubject = 'allowTraffic'
    state.filterIpType = 'v46'

    state.filterDate = 360 // 6h
    state.filterDevice = void 0
    state.filterDeviceText = ''
    state.filterDeviceNot = false
  },
  setDashboardTimer (state, timerValue) {
    state.refreshTime = timerValue
  },
  setFilterDate (state, payload) {
    state.filterDate = payload
  },
  setFilterDevice (state, filterDevice) {
    state.filterDevice = filterDevice
  },
  setFilterDeviceText (state, filterDeviceText) {
    state.filterDeviceText = filterDeviceText
  },
  setFilterDeviceNot (state, filterDeviceNot) {
    state.filterDeviceNot = filterDeviceNot
  },
  setFilterIpType (state, filterIpType) {
    state.filterIpType = filterIpType
  },
  setCountrySubject (state, countrySubject) {
    state.countrySubject = countrySubject
  }
}
export const actions = {
  // async getDeviceStatusData ({ state, commit }) {
  //   // Axios 호출
  //   const apiUrl = `/api/da/dashboard/device-status`
  //   const { code, result } = await this.$axios.$post(apiUrl, {
  //     filters: [
  //       {
  //         key: 'mach_id',
  //         value: state.filterDeviceText,
  //         is_not_false: state.filterDeviceNot
  //       }
  //     ]
  //   }, {
  //     loading: false,
  //     successAlert: false
  //   })
  //
  //   // 호출된 데이터 확인
  //   if (code === 'ok') {
  //     commit('setDeviceStatusData', result)
  //   }
  // }
}

export const getters = {}
export const strict = false
